export default __webpack_public_path__ + "static/media/btnMinus.06653e5b.svg";